<div *ngIf="clientType && clientType === 'Organisation'">
  Type of ID is Organisation. you cann't modify Person data.
</div>
<form *ngIf="!clientType || clientType === 'Person'" [formGroup]="personForm" class="flex flex-col flex-1-0-auto">
  <div class="w-n-600 flex flex-col">
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>Preceding Title</mat-label>
        <input formControlName="PrecedingTitle_6_p" matInput placeholder=""
               particleAnalytics
               analyticsAction="PrecedingTitle_6_p-input"
        />
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>Title</mat-label>
        <input formControlName="Title_6_p" matInput placeholder=""
               particleAnalytics
               analyticsAction="Title_6_p-input"
        />
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>First Name</mat-label>
        <input formControlName="FirstName_6_p" matInput placeholder="" required
               particleAnalytics
               analyticsAction="FirstName_6_p-input"
        />
        <mat-error *ngIf="personFormErrors.FirstName_6_p.required">
          First Name is required!
        </mat-error>
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>Middle Name</mat-label>
        <input formControlName="MiddleName_6_p" matInput placeholder=""
               particleAnalytics
               analyticsAction="MiddleName_6_p-input"
        />
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>Name Prefix</mat-label>
        <input formControlName="NamePrefix_6_p" matInput placeholder=""
               particleAnalytics
               analyticsAction="NamePrefix_6_p-input"
        />
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>Last Name</mat-label>
        <input formControlName="LastName_6_p" matInput placeholder="" required
               particleAnalytics
               analyticsAction="LastName_6_p-input"
        />
        <mat-error *ngIf="personFormErrors.LastName_6_p.required">
          Last Name is required!
        </mat-error>
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>Generation Identifier</mat-label>
        <input formControlName="GenerationIdentifier_6_p" matInput placeholder=""
               particleAnalytics
               analyticsAction="GenerationIdentifier_6_p-input"
        />
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>Suffix</mat-label>
        <input formControlName="Suffix_6_p" matInput placeholder=""
               particleAnalytics
               analyticsAction="Suffix_6_p-input"
        />
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>General Suffix</mat-label>
        <input formControlName="GeneralSuffix_6_p" matInput placeholder=""
               particleAnalytics
               analyticsAction="GeneralSuffix_6_p-input"
        />
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="orbitax-date-picker flex-0-0-100">
        <mat-label>Date of birth</mat-label>
        <input formControlName="DateOfBirth_6_p" matInput [matDatepicker]="picker1" placeholder="" required
               particleAnalytics
               analyticsCategory="date-time-cell"
               analyticsAction="date-picker">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
        <mat-error *ngIf="personFormErrors.DateOfBirth_6_p.required">
          Date of birth is required!
        </mat-error>
      </mat-form-field>
    </div>
    <!--<div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto" >
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>Place of birth</mat-label>
        <input formControlName="PlaceOfBirth_6_p" matInput placeholder="" required
               particleAnalytics
               analyticsAction= "Suffix_6_p-input"
        />
        <mat-error *ngIf="personFormErrors.PlaceOfBirth_6_p.required">
          Place of birth is required!
        </mat-error>
      </mat-form-field>

    </div>-->
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="flex-0-0-100">
        <mat-label>Place of birth</mat-label>
        <mat-select formControlName="PlaceOfBirth_6_p" required>
          <mat-option *ngFor="let country of countryList" [value]="country.code">
            {{country.name}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="personFormErrors.PlaceOfBirth_6_p.required">
          Place of birth is required!
        </mat-error>
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="flex-0-0-100">
        <mat-label>Country of Residence</mat-label>
        <mat-select formControlName="ResidenceCountryCode_11_p" required>
          <mat-option *ngFor="let country of countryList" [value]="country.code">
            {{country.name}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="personFormErrors.ResidenceCountryCode_11_p.required">
          Country of Residence is required!
        </mat-error>
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>Tin</mat-label>
        <input formControlName="Tin_11_p" matInput placeholder=""
               particleAnalytics
               analyticsAction="Tin_11_p-input"
        />
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>Email</mat-label>
        <input formControlName="Email_6_p" matInput placeholder=""
               particleAnalytics
               analyticsAction="Email_6_p-input"
        />
      </mat-form-field>
    </div>
  </div>
</form>
